import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { PhoneNumberUtil } from "google-libphonenumber";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import PartyForm from "./PartyForm";

const phoneUtil = PhoneNumberUtil.getInstance();
const schema = yup.object({
  full_name: yup.string().required("Full name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  account: yup.string().required("Account Type is required"),
  mobile_number: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
});

const SupplierEditForm = ({ data, handleEdit, isLoading }: any) => {
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    setError,
    watch,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: async () => {
      return {
        ...data,
      };
    },
  });

  return (
    <Card>
      <form onSubmit={handleSubmit((data) => handleEdit(data, setError))}>
        <PartyForm
          control={control}
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          watch={watch}
        />
        <div className={tw`mt-4 w-full px-4 `}>
          <div className={tw`w-32 ml-auto`}>
            <Button label="Update" isLoading={isLoading} />
          </div>
        </div>
      </form>
    </Card>
  );
};

export default SupplierEditForm;

